var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info"},[_c('div',[_c('el-avatar',{attrs:{"size":70,"src":_vm.loginUser.avatar}}),_c('div',{staticStyle:{"text-align":"center","font-size":"16px"}},[_vm._v(_vm._s(_vm.loginUser.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }